import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { ImageIcon } from '@sketchnote/icons';
import { Button, LoaderXs, Panel, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { useReadOnly } from 'slate-react';

import { useSlatePluginsStore } from '../store';

const { useState, useRef } = React;

export const UploadImageEditor = ({ onSubmit }: { onSubmit: (url: string) => void }) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { uploadImage } = useSlatePluginsStore();
  const toggleMenu = (value?: boolean) => () => {
    setIsOpenMenu(value ?? !isOpenMenu);
  };
  const isReadOnly = useReadOnly();

  const handleOnOpenDialog = () => {
    inputRef.current?.click();
  };
  const onUploadImage: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader();
        const [mime] = file.type.split('/');

        if (mime === 'image') {
          reader.addEventListener('load', async () => {
            if (!reader.result) {
              return;
            }
            setIsLoading(true);
            const uploadedUrl = uploadImage
              ? await uploadImage(reader.result)
              : (reader.result as string);
            setIsLoading(false);
            onSubmit(uploadedUrl);
          });

          reader.readAsDataURL(file);
        }
      }
    }
  };
  return (
    <Popover
      placement="bottom"
      isOpen={isOpenMenu}
      onOpen={toggleMenu(true)}
      onClose={toggleMenu(false)}
      modifiers={[{ name: 'eventListeners', options: { scroll: isOpenMenu } }]}
    >
      <PopoverTrigger>
        <button
          disabled={isReadOnly}
          className="px-16 py-10 w-full flex bg-gray-100 hover:bg-gray-200 items-center"
        >
          {isLoading ? (
            <LoaderXs />
          ) : (
            <React.Fragment>
              <ImageIcon />
              <span className="ml-8">Add an image</span>
            </React.Fragment>
          )}
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>
          {!isLoading ? (
            <div className="flex flex-col p-16 rounded-lg bg-white shadow-sm text-gray-999 min-w-400">
              <Tabs selected={0} size="small" className="border-b">
                <Panel title="Upload">
                  <div className="my-16">
                    <input
                      id="editor-image-upload"
                      ref={inputRef}
                      type="file"
                      accept="image/*"
                      name="image"
                      alt="upload image"
                      hidden
                      onChange={onUploadImage}
                    />
                    <Button onClick={handleOnOpenDialog} className="justify-center w-full">
                      Choose an Image
                    </Button>
                  </div>
                </Panel>
              </Tabs>
            </div>
          ) : null}
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
